module.exports = __webpack_public_path__ + "img/barzahlen.270a07e7.png";